import {
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  signOut,
} from "aws-amplify/auth";

const SEARCH_PARAMS_PREVIOUS_ROUTE = "previous";

export const redirectSignInWithPreviousRoute = () => {
  const previousRoute = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  const searchParams = new URLSearchParams();
  searchParams.set(SEARCH_PARAMS_PREVIOUS_ROUTE, previousRoute);
  const search = searchParams.toString();

  window.location.assign(`/?${search}`);
};

const signOutInNotAuthorizedExceptionError = async (error: unknown) => {
  if (error instanceof Error === false) {
    return;
  }

  if (error.name !== "NotAuthorizedException") {
    return;
  }

  await signOut();
};

export const getIsAuthenticated = async () => {
  try {
    await getCurrentUser();
    return true;
  } catch (error) {
    await signOutInNotAuthorizedExceptionError(error);
    console.log("error getIsAuthenticated: ", error);
    return false;
  }
};

export const getUserUsername = async () => {
  try {
    const username = (await getCurrentUser()).username;
    return username;
  } catch (error) {
    console.log("error getUserUsername: ", error);
    return;
  }
};

export const getUserAttributesEmail = async () => {
  try {
    const email = (await fetchUserAttributes()).email;
    return email;
  } catch (error) {
    await signOutInNotAuthorizedExceptionError(error);
    console.log("error getUserAttributesEmail: ", error);
    return;
  }
};

export const handleSignOut = async () => {
  try {
    await signOut();
  } catch (error) {
    console.log("error signing out: ", error);
    throw error;
  }
};

export const getIdToken = async () => {
  try {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();

    if (token === undefined) {
      throw new Error("idToken is undefined");
    }

    return token;
  } catch (error) {
    redirectSignInWithPreviousRoute();
    console.error("error getIdToken: ", error);
    throw new Error("idToken is undefined");
  }
};

export const getAccessToken = async () => {
  try {
    const token = (await fetchAuthSession()).tokens?.accessToken.toString();

    if (token === undefined) {
      throw new Error("accessToken is undefined");
    }

    return token;
  } catch (error) {
    console.log("error getAccessToken: ", error);
    throw new Error("accessToken is undefined");
  }
};
